export default __webpack_public_path__ + "static/media/james.e18b2e5a.png";